/**
 * ThumbUpIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ThumbUpIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M11.054 5.29a2.485 2.485 0 0 1 3.887-.066l.133.177c.292.423.448.927.449 1.442v2.52h2.345a2.56 2.56 0 0 1 2.12 1.133l.328.49.076.12a2.55 2.55 0 0 1 .256 2.005l-1.359 4.722a2.55 2.55 0 0 1-2.45 1.844h-6.29a2.55 2.55 0 0 1-1.866-.814l-.141-.15a1.8 1.8 0 0 1-1.598.967H5.056a1.806 1.806 0 0 1-1.806-1.805v-7.389c0-.997.809-1.806 1.806-1.806h1.888c.448 0 .857.164 1.172.434zm-5.998 4.89a.306.306 0 0 0-.306.306v7.389c0 .168.137.305.306.305h1.888a.306.306 0 0 0 .306-.305v-7.389a.306.306 0 0 0-.306-.306zm8.728-4.002a.985.985 0 0 0-1.464-.062l-.076.089-3.494 4.549v5.977l1.031 1.111c.198.213.477.335.769.335h6.289c.467 0 .879-.31 1.009-.76l1.358-4.721a1.05 1.05 0 0 0-.137-.875l-.328-.49a1.05 1.05 0 0 0-.873-.467h-3.095a.75.75 0 0 1-.75-.75v-3.27c0-.244-.086-.48-.239-.666"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ThumbUpIcon = makeIcon('ThumbUpIcon', ThumbUpIconSvg)
